/**
 * Venue partner portal: `venueApi` (token: 'token' — venue partners log in
 * through the unified auth). Endpoints called today by pages/venue/*.
 */
import { createClient } from './client';

export const venueApi = createClient('venue');

export const getVenuePartner = (venuePartnerId, config) => venueApi.get(`/venue/partner/${venuePartnerId}`, config);
export const updateVenuePartner = (venuePartnerId, payload, config) => venueApi.put(`/venue/partner/${venuePartnerId}`, payload, config);
export const uploadVenuePartnerLogo = (venuePartnerId, formData, config) =>
  venueApi.post(`/venue/partner/${venuePartnerId}/logo`, formData, config);
export const getVenueHubLocation = (locationId, config) => venueApi.get(`/locations/${locationId}`, config);
export const getVenueHubBusinesses = (locationId, config) => venueApi.get(`/locations/${locationId}/businesses`, config);
export const getVenueDesigns = (config) => venueApi.get('/venue/designs', config);
export const changeCoasterDesign = (payload, config) => venueApi.post('/venue/change-design', payload, config);
export const uploadVenueApplicationLogo = (formData, config) => venueApi.post('/venue/upload-logo', formData, config);
export const submitVenueApplication = (payload, config) => venueApi.post('/venue/apply', payload, config);
